<app-modal [modalTitleText]="headerText" [cancelButtonText]="closeText" [primaryButtonEnabled]="false" (cancelButtonAction)="closeModal()">
  <app-accessibility-statement [footerStickyEnabled]="false" modal-content></app-accessibility-statement>
</app-modal>
